module.exports = __webpack_public_path__ + "img/3.5.22b85386.png";